// extracted by mini-css-extract-plugin
module.exports = {"closeBtn":"SideMenu_closeBtn__9xxdL","backdrop":"SideMenu_backdrop__Hjzgs","wrapper":"SideMenu_wrapper__3fHQ_"};